module.exports = __webpack_public_path__ + "videos/escaping-artist-and-marketing-genius.1585a0a.mp4";